import baseService from "@common/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apiDef = {
  getIdSolicitacao(data) {
    return http.get("/DecaSolicitacaoExterno/IdSolicitacao", {
      params: {
        numero: data.NumeroSolicitacao,
        cpfcnpj: data.CpfCnpj,
      },
    });
  },
};

export default apiDef;
